import React, { useEffect, useRef } from "react";
import classes from "./IframeWrapper.module.scss";
import { getContentWindow, setContentWindow } from "./ContentWindowStore";
import UsersService from "@velocity-ehs/user-utils-module";
import {
  confirmedCookieKey,
  getCookieDisclaimerKey,
} from "../Home/CookieDisclaimer";

interface IframeWrapperProps {
  appUrl: string;
  hostedAppName: string;
  iframeProps?: React.ComponentProps<"iframe">;
}

const IframeWrapper: React.FC<IframeWrapperProps> = (props) => {
  const appFrameRef = useRef(null);
  const iframe = getContentWindow(props.hostedAppName);
  const hasConfirmedCookies: boolean =
    window.localStorage[
      getCookieDisclaimerKey(
        UsersService.user?.actualLoginName,
        confirmedCookieKey
      )
    ] || false;

  const onHandshake = (e) => {
    if (e.data.appName === props.hostedAppName) {
      const sub = iframe.subscribe((contentWindow) => {
        contentWindow?.postMessage(
          { accelerate: true, hasConfirmedCookies },
          "*"
        );
      });

      sub.unsubscribe();
    }
  };

  const logout = () => {
    const sub = iframe.subscribe((contentWindow) => {
      contentWindow?.postMessage({ appLogout: true }, "*");
    });

    sub.unsubscribe();
  };

  useEffect(() => {
    try {
      UsersService.subscribe("LOGOUT", logout);
      if (appFrameRef.current) {
        setContentWindow(
          props.hostedAppName,
          appFrameRef.current.contentWindow
        );
      }

      window.addEventListener("message", onHandshake);

      return () => {
        UsersService.unsubscribe("LOGOUT", logout);
        window.removeEventListener("message", onHandshake);
      };
    } catch (e) {
      console.error(e);
      console.error("Error registering logout functionality");
    }
    /* eslint-disable-next-line react-hooks/exhaustive-deps */
  }, []);

  return (
    <div className={classes.iframeContainer}>
      <iframe
        id="appFrame"
        title={props.hostedAppName}
        ref={appFrameRef}
        src={props.appUrl}
        width="100%"
        height="100%"
        {...props.iframeProps}
      ></iframe>
    </div>
  );
};

export default IframeWrapper;
